module.exports = __webpack_public_path__ + "img/facil_acesso_icon.2eb24fa2.svg";